export const COLUMNS_DETALLE_POR_CEREAL_LINEA_3 = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'pesoNetoCerealLinea6',
    label: 'Linea 6 [Tns]',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'pesoNetoCerealLinea5',
    label: 'Linea 5 [Tns]',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'pesoNetoCerealLinea7',
    label: 'Linea 7 [Tns]',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'pesoNetoCerealHumedad',
    label: 'Humedad [Tns]',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'pesoNetoTotal',
    label: 'Total [Tns]',
    options: {
      filter: true,
      sort: true
    }
  }
]
export const COLUMNS_DETALLE_POR_CEREAL_LINEA_3_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'pesoNetoCerealLinea6',
    label: 'Linea 6 [Tns]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoNetoCerealLinea5',
    label: 'Linea 5 [Tn]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoNetoCerealLinea7',
    label: 'Linea 7 [Tns]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoNetoCerealHumedad',
    label: 'Humedad [Tns]',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'pesoNetoTotal',
    label: 'Total [Tns]',
    width: 60,
    mantenerCase: true
  }
]
